module.exports = __webpack_public_path__ + "static/media/advisory.6dd20f80.svg";